import { Component, OnDestroy, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { SharedService } from '../shared.service';
import { combineLatest } from 'rxjs';
import { MainService } from '../main.service';
import { localStorageService } from '../localstorage.service';

@Component({
  selector: 'app-assignment-tabs',
  // standalone: true,
  // imports: [],
  templateUrl: './assignment-tabs.component.html',
  styleUrl: './assignment-tabs.component.scss'
})
export class AssignmentTabsComponent implements OnInit, OnDestroy {
  assignmentType:number=4;
  subscription: any;
  subscription1: any;  
  show_disp_button:boolean = false
  constructor(
    public router: ActivatedRoute,
    public _shared: SharedService,
    public mainService : MainService,
    public _local: localStorageService
    ) { }

    ngOnInit() {
      this.subscription = combineLatest([this.router.url, this.router.queryParams]).subscribe(([url, data]: any) => {
        if (url?.[0]?.path === "assignments") {
          this.assignmentType = data?.type || 4;
        } else {
          this.assignmentType = 0;
        }
      });
      this.subscription1 = this.mainService.dispute_docs_allowed_admins$.subscribe((data: any) => {
        let asset_admins;
        if (data && data.length) {
          asset_admins = data || [];
          let admin_id = (this._local.customGetItem('admin_profile')).admin_id;
          if (asset_admins.includes(admin_id)) {
            this.show_disp_button = true;
          }
        }
      });
    }
    
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
}
